<template>
  <div v-if="visible">
    <NuxtLink v-if="target && type === 'route'" :to="{name: target}"
      :class="[{
        'px-0 gap-3 h-10':collapseSidebar,
        'px-0 gap-3 h-12':!collapseSidebar
      }]"
    class="w-full py-1 rounded-lg justify-start items-center inline-flex flex-no-wrap text-gray-500 hover:bg-f-primary-orange hover:px-3 hover:text-white cursor-pointer transition-all">
      <div :class="[{ 'w-full flex justify-center':collapseSidebar, 'w-5':!collapseSidebar }]" class="h-5 relative">
        <slot name="icon"/>
      </div>
      <div :class="[{ 'hidden':collapseSidebar }]" class="text-sm font-['Inter'] capitalize leading-snug">
        <slot name="label" /> {{ super_user }}
      </div>
    </NuxtLink>

    <a v-else
      :class="[{
        'px-0 gap-3 h-10':collapseSidebar,
        'px-0 gap-3 h-12':!collapseSidebar
      }]"
    class="w-full py-1 rounded-lg justify-start items-center inline-flex flex-no-wrap text-gray-500 hover:bg-f-primary-orange hover:px-3 hover:text-white cursor-pointer transition-all">
      <div :class="[{ 'w-full flex justify-center':collapseSidebar, 'w-5':!collapseSidebar }]" class="h-5 relative">
        <slot name="icon"/>
      </div>
      <div :class="[{ 'hidden':collapseSidebar }, {'w-full': locked}]" class="text-sm font-['Inter'] capitalize leading-snug">

        <slot v-if="!locked" name="label" />
        <div v-else class="flex w-full justify-between items-center">
          <slot name="label" />
          <div class="text-xs p-1 bg-gray-100 text-gray-600 hover:text-gray-600 rounded flex gap-1 items-center">
            <svg class="w-4 h-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99935 10.5559V11.8892M3.99935 14.5559H11.9993C12.7357 14.5559 13.3327 13.959 13.3327 13.2226V9.22258C13.3327 8.4862 12.7357 7.88924 11.9993 7.88924H3.99935C3.26297 7.88924 2.66602 8.4862 2.66602 9.22258V13.2226C2.66602 13.959 3.26297 14.5559 3.99935 14.5559ZM10.666 7.88924V5.22257C10.666 3.74982 9.47211 2.55591 7.99935 2.55591C6.52659 2.55591 5.33268 3.74982 5.33268 5.22257V7.88924H10.666Z" stroke="#637381" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { watch } from 'vue';
const sidebarStore = useAdminSidebarStore();
const collapseSidebar = computed(() => sidebarStore.$state.collapseSidebar);
const sessionStore = useSessionStore();
const profile = computed(() => sessionStore.$state.profile);
const visible = ref(true);
const props = defineProps({
  type: {
    type: String,
    default: 'route',
  },
  target: {
    type: String,
    default: '',
  },
  locked: {
    type: Boolean,
    default: false,
  },
  superUser: {
    type: Boolean,
    default: false,
  },
  owner: {
    type: String,
    default: '',
  },
});

onBeforeMount(() => {
  checkVisibility();
});

const checkVisibility = () => {
  if (props.superUser) {
    if (profile.value.roleId === 'super_admin') {
      visible.value = true;
    } else {
      visible.value = false;
    }
  }
};

</script>

<style lang="scss" scoped>

</style>
